var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { makeStyles } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { FTLTypography } from "../FTLTypography";
export const FTLPhoneCode = React.forwardRef((_a, ref) => {
    var { className, children } = _a, otherProps = __rest(_a, ["className", "children"]);
    const classes = useStyles();
    return (React.createElement("div", Object.assign({}, otherProps, { className: classNames(classes.root, className) }),
        React.createElement(FTLTypography, { variant: "p2", color: "disable", ref: ref }, children)));
});
const useStyles = makeStyles((theme) => ({
    root: {
        background: theme.palette.textField.disabled,
        borderRadius: 4,
        minWidth: 80,
        height: 40,
        padding: "10px 8px",
        boxSizing: "border-box",
        flexShrink: 0,
        marginRight: 8,
    },
}));
//# sourceMappingURL=FTLPhoneCode.js.map